import { section } from "@/glow";
import { animateApps, shouldAnimate } from "@/lib/animation";

section("apps", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateApps = animateApps(this.container);
    }
  },

  onUnload() {
    this.animateApps?.destroy();
  },
});
